import {requestControl} from '@/shared/api';
import type {NotificationSettings} from '@/entities/notification-settings/types';

export function fetchNotificationSettings(companyId: string): Promise<NotificationSettings> {
  return requestControl<NotificationSettings>('/control/settings/notifications', companyId);
}

export function saveNotificationSettings(
  companyId: string,
  settings: NotificationSettings,
): Promise<NotificationSettings> {
  return requestControl<NotificationSettings>('/control/settings/notifications', companyId, {
    method: 'PATCH',
    body: JSON.stringify(settings),
  });
}
